export const staticWidgetListMock = {
    client: [
        {
            value: 'conversions',
            label: 'Conversions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_goal',
            label: 'Cost per Goal',
            metricOrigin: 'From Google Analytics',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'sessions',
            label: 'Session',
            metricOrigin: 'From Google Analytics',
        },
        {
            value: 'cpc',
            label: 'CPC',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cpm',
            label: 'CPM',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'ctr',
            label: 'CTR',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'conv_rate',
            label: 'Conv. Rate',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
    facebook_ads: [
        {
            value: 'conversions',
            label: 'Conversions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_conversion',
            label: 'CPA',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'reach',
            label: 'Reach',
        },
        {
            value: 'cpc',
            label: 'CPC',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cpm',
            label: 'CPM',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'ctr',
            label: 'CTR',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'conv_rate',
            label: 'Conv. Rate',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
    google_ads: [
        {
            value: 'conversions',
            label: 'Conversions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_conversion',
            label: 'CPA',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'videoviews',
            label: 'Video Views',
        },
        {
            value: 'cpc',
            label: 'CPC',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cpm',
            label: 'CPM',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'ctr',
            label: 'CTR',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'conv_rate',
            label: 'Conv. Rate',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
};

export const invalidBigNumberConfigMock = {
    client: [
        {
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_goal',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
    facebook_ads: [
        {
            value: 'conversions',
            label: 'Conversions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_conversion',
            label: 'CPA',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
    google_ads: [
        {
            value: 'cpm',
            label: 'CPM',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'cost_per_conversion',
            label: 'CPA',
        },
        {
            value: 'cost',
            label: 'Investment',
            isInverseMetric: true,
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'impressions',
            label: 'Impressions',
            metricOrigin: 'From Google and Facebook Ads',
        },
        {
            value: 'clicks',
            label: 'Clicks',
            metricOrigin: 'From Google and Facebook Ads',
        },
    ],
};

export const metricsMock = {
    absolutetopimpressionperventage: 0,
    average_ticket: 0,
    averagecpv: 0,
    clicks: 0,
    conv_rate: 0,
    conv_value_conversion: 0,
    conversion: 0,
    conversionValue: 0,
    conversions: 0,
    cost: 0,
    cost_conv_value: 0,
    cost_per_conversion: 0,
    cost_per_goal: 0,
    cost_per_transaction: 0,
    cpc: 0,
    currencycode: null,
    date: '2020-12-07T00:00:00.000+0000',
    dayofweek: null,
    deal_won: 0,
    deal_won_value: 0,
    pipedrive_cpa: 0,
    pipedrive_roi: 0,
    goalCompletion: 0,
    goalCompletionValue: 0,
    hourofday: null,
    impression_share: 0,
    impressions: 0,
    month: null,
    newUsers: 0,
    order_quantity: 0,
    pageViews: 0,
    quarter: null,
    reach: 0,
    revenue: 0,
    roas: 0,
    roi_ga: 0,
    sessions: 0,
    shopify_average_ticket: 0,
    shopify_order_quantity: 0,
    shopify_total_value: 0,
    total_value: 0,
    transactions: 0,
    transactionsRevenue: 0,
    users: 0,
    videoviewrate: 0,
    videoviews: 0,
    week: null,
    woocommerce_average_ticket: 0,
    woocommerce_order_quantity: 0,
    woocommerce_total_value: 0,
};
